import { Card } from "@/src/components/shadcn/ui/card";
import { cn } from "@/src/lib/shadcn-utils";

export function EhrInstructionsCard({
  children,
  className,
  collapsibleTitle,
}: {
  children: React.ReactNode;
  className?: string;
  collapsibleTitle?: string;
}) {
  const card = (
    <Card className={cn("p-6 border bg-ehr/5 dark:bg-ehr/20 rounded-lg", !collapsibleTitle && className)}>
      {children}
    </Card>
  );

  if (!collapsibleTitle) return card;

  return (
    <details className={className}>
      <summary className="cursor-pointer text-sm font-medium text-muted-foreground">{collapsibleTitle}</summary>
      <div className="mt-4">{card}</div>
    </details>
  );
}
